import { PayrollSettings } from "../../../../../Invoices/screens/payables/PayrollSettings";

export const RouteSchedule: React.FC = () => {
  return <PayrollSettings />;
};
